
























import Vue from "vue";

export default Vue.extend({
  props: {
    value: {
      type: String,
      required: false,
      default: "",
    },
    classes: {
      type: Object,
      required: false,
      default: function(): Record<string, unknown> { return { "": [] }}
    },
    options: {
      type: Object,
      required: true,
    },
    requiredPrompt: {
      type: Boolean,
      required: false,
      default: true,
    },
    inputName: {
      type: String,
      required: true
    },
    selectId: {
      type: String,
      required: true
    },
  },
});
